import { Component, OnInit } from '@angular/core';
import { ActivityInternalTableComponent } from 'gung-standard';

@Component({
    selector: 'cult-cult-activity-internal-table',
    templateUrl: './cult-activity-internal-table.component.html',
    styleUrls: ['./cult-activity-internal-table.component.scss'],
    standalone: false
})
export class CultActivityInternalTableComponent extends ActivityInternalTableComponent {}